import { categories, categoryImages } from '@/mocks/categories';

export default function CategoriesSection() {
  return (
    <section className="py-14 md:py-20 bg-background-100">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <span className="inline-block px-3 py-1 rounded-full bg-secondary-100 text-secondary-700 text-xs font-medium mb-4">
            Kategorie
          </span>
          <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-950 mb-4">
            Przeglądaj kategorie produktów
          </h2>
          <p className="text-foreground-600 max-w-[600px] mx-auto leading-relaxed">
            Odkryj szeroki wybór kategorii dostępnych w naszym sklepie. 
            Każda kategoria oferuje starannie wyselekcjonowane produkty.
          </p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 gap-3 md:gap-4">
          {categories.map((cat, idx) => (
            <a
              key={cat.name}
              href={cat.url}
              target="_blank"
              rel="noopener nofollow"
              className="group flex flex-col rounded-xl bg-background-50 border border-background-200/70 hover:border-primary-300 hover:shadow-sm transition-all duration-300 cursor-pointer overflow-hidden"
            >
              <div className="aspect-[4/3] overflow-hidden">
                <img
                  src={categoryImages[idx]}
                  alt={cat.name}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  loading="lazy"
                />
              </div>
              <div className="flex items-center gap-2.5 px-4 py-3">
                <span className="w-8 h-8 flex-shrink-0 flex items-center justify-center rounded-lg bg-primary-100 text-primary-600 group-hover:bg-primary-500 group-hover:text-background-50 transition-colors duration-300">
                  <i className={`${cat.icon} text-sm`}></i>
                </span>
                <span className="text-sm font-medium text-foreground-700 group-hover:text-foreground-950">
                  {cat.name}
                </span>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}